import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

const BUILD_META_URL = "/build-meta.json";
const BUILD_RELOAD_KEY = "vip:build:reloaded";
const BUILD_POLL_INTERVAL_MS = 30000;

const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) {
    return Promise.resolve();
  }

  return navigator.serviceWorker.register("/sw.js").catch(() => undefined);
};

const clearBrowserCaches = () => {
  if (!("caches" in window)) {
    return Promise.resolve();
  }

  return caches
    .keys()
    .then(keys => Promise.all(keys.map(key => caches.delete(key))))
    .catch(() => undefined);
};

const fetchBuildVersion = async () => {
  try {
    const response = await fetch(`${BUILD_META_URL}?t=${Date.now()}`, {
      cache: "no-store",
      headers: {
        "cache-control": "no-cache"
      }
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    return String(data?.version || data?.buildId || "");
  } catch (error) {
    return null;
  }
};

const forceAppRefresh = async version => {
  const lastReloadedVersion = sessionStorage.getItem(BUILD_RELOAD_KEY);

  if (lastReloadedVersion === version) {
    return;
  }

  sessionStorage.setItem(BUILD_RELOAD_KEY, version);

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistration().then(registration => {
      registration?.update().catch(() => undefined);
    });
  }

  await clearBrowserCaches();

  window.location.reload();
};

const startBuildWatcher = async () => {
  let currentVersion = await fetchBuildVersion();

  const checkVersion = async () => {
    const latestVersion = await fetchBuildVersion();

    if (!latestVersion) {
      return;
    }

    if (!currentVersion) {
      currentVersion = latestVersion;
      return;
    }

    if (latestVersion !== currentVersion) {
      await forceAppRefresh(latestVersion);
    }
  };

  setInterval(checkVersion, BUILD_POLL_INTERVAL_MS);
  window.addEventListener("focus", () => {
    checkVersion().catch(() => undefined);
  });
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      checkVersion().catch(() => undefined);
    }
  });
};

ReactDOM.render(<App />, document.getElementById("root"));

window.addEventListener("load", () => {
  registerServiceWorker().catch(() => undefined);
  startBuildWatcher().catch(() => undefined);
});
